<template>
  <a class="course-link">
    <div
      class="card-img"
      :style="{ backgroundImage: `url(${getInstructorImg(course.instructorPhoto)})` }"
    >
      <div v-if="$config.platform === 'ds'" class="tech-img" :class="course.technology.replace(' ', '-')">
        <Component :is="getTech(course.technology.replace(' ', '-'))" />
      </div>
    </div>
    <div class="card-info">
      <div class="card-head">
        <component :is="heading" class="h5 card-title">
          {{ course.name }}
        </component>
        <p>with {{ course.instructor }}</p>
      </div>
      <div v-if="$store.state.layout !== 'mobile'" class="card-body">
        <p>{{ course.description }}</p>
      </div>
      <div class="card-footer caption">
        <template v-if="$config.platform === 'ds'">
          <span>{{ course.lessons }} Lessons</span>
          <span class="bullet" />
          <span>{{ course.duration }} hours</span>
        </template>
        <template v-else-if="$config.platform === 'fa'">
          <span>{{ course.duration }} hours</span>
          <span class="bullet" />
          <span>{{ course.lessons }} Lessons</span>
        </template>
      </div>
    </div>
  </a>
</template>

<script>
/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */

export default {
  components: {},
  props: {
    course: { type: Object, default: () => {} },
    heading: { type: String, default: 'h5' },
  },
  mounted() {},
  methods: {
    getInstructorImg(img) {
      if (process.client) {
        return `${this.$config.imagesUrl}/upcoming-courses/${img}`;
      }
      return '';
    },
    getTech(tech) {
      return require(`../assets/svg/tech-responsive-${tech.replace(' ', '-')}.svg?vue-component`);
    },
  },
};
</script>

<style lang="scss" scoped>
.course-link {
  background: var(--main-light);
  border: 1px solid var(--main-light);
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
  border-radius: 10px;
  padding: var(--spacing-12);
  padding-right: var(--spacing-60);
  align-items: center;
  display: flex;
  transition: all var(--duration) ease;
  height: 240px;

  .card-img {
    background-position: 100%;
    background-repeat: no-repeat;
    image-rendering: -webkit-optimize-contrast;
    width: 340px;
    height: 220px;
    background-size: cover;
    border-radius: 4px;
    flex: 0 0 auto;

    .tech-img {
      text-align: right;
      margin: 12px 12px 0 0;

      svg {
        filter: drop-shadow(0 2px 10px rgba(0, 12, 31, 0.5));
        max-width: 46px;
        max-height: 49px;
      }

      &.sql svg {
        max-width: 49px;
        max-height: 19px;
      }

      &.jupyter svg {
        max-width: 33px;
        max-height: 38px;
      }

      &.theory svg {
        max-width: 35px;
        max-height: 29px;
      }

      &.python svg {
        max-width: 38px;
        max-height: auto;
      }

      &.git svg {
        max-width: 38px;
        max-height: auto;
      }

      &.excel svg {
        max-width: 33px;
        max-height: auto;
      }

      &.tableau svg {
        max-width: 40px;
        max-height: auto;
      }

      &.powerbi svg {
        max-width: 33px;
        max-height: 25px;
      }

      &.r svg {
        max-width: 36px;
        max-height: 28px;
      }

      &.data svg {
        max-width: 46px;
        max-height: 49px;
      }
    }
  }

  .card-info {
    max-width: 58%;
    margin-left: var(--spacing-36);
    padding: var(--spacing-sm) 0;
    width: 100%;

    .card-head {
      .card-title {
        margin: 0;
      }

      p {
        margin-bottom: 0;
        color: var(--main-dark-shade-3);
      }
    }

    .card-body {
      margin: var(--spacing-sm) 0;

      p {
        margin: 0;
        color: var(--main-dark-shade-3);
        display: block;
        display: -webkit-box;
        line-height: 1.2;
        -webkit-line-clamp: 3;
        margin-bottom: 16px;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .card-footer {
      display: flex;
      align-items: center;

      span {
        line-height: 150%;

        &.bullet {
          background: var(--true-black);
          height: 4px;
          width: 4px;
          border-radius: 50%;
          margin: 0 var(--spacing-xs);
        }
      }
    }
  }

  &:hover {
    transform: scale(1.01);
    transition: all var(--duration) ease;
  }

  @include bp($bp-mobile) {
    flex-direction: column;
    padding: 0;
    height: auto;
    margin: var(--spacing-16) 0;
    border: none;

    .card-img {
      width: 100%;
      height: 0;
      padding-bottom: 66%;
      background-position: center;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    .card-info {
      padding: var(--spacing-12) var(--spacing-32) var(--spacing-16);
      margin: 0;
      max-width: 100%;

      .card-head {
        .card-title {
          font-weight: 600;
          font-size: 16px;
          line-height: 23px;
        }

        p {
          margin-top: var(--spacing-4);
          font-weight: normal;
          line-height: 27px;
        }
      }

      .card-footer {
        font-weight: 500;
        font-size: 14px;
      }
    }

    .card-footer {
      margin-top: 16px;
    }
  }
}

.fa {
  @include bp($bp-mobile) {
    .course-link {
      .card-img {
        padding-bottom: 68%;
      }
    }
  }
}
</style>
